
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'IconArrow',
  props: {
    width: {
      type: [String, Number] as PropType<string | number>,
      default: 10
    },
    height: {
      type: [String, Number] as PropType<string | number>,
      default: 10
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
})
